import React, { useEffect } from 'react';
import { AsideAbout } from '../../_layout/aside-about';

export function Policy() {
  useEffect(() => {}, []);

  return (
    <main className="sub about wrapper">
      <AsideAbout />
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>이용약관</>
        </div>
        <div className="title">
          <h2>이용약관</h2>
          <p>도서출판 구민사의 홈페이지의 이용약관입니다.</p>
        </div>
        <section>
          <h3>제1장 총 칙</h3>
          <h4>제1조 (명칭)</h4>
          <p>
            본 사이트는 &quot;구민사 공식 홈페이지&quot;로 칭하며 본 사이트의 운영주체는
            구민사입니다.
          </p>
          <h4>제2조 (목적)</h4>
          <p>
            본 약관은 회원들이 본 정보를 이용함에 있어 본 사이트와 가입 회원(이하 회원) 간의 관계
            설정을 목적으로 합니다.
          </p>
          <h4>제3조 (약관의 변경)</h4>
          <p>
            본 사이트가 약관을 변경하고자 할 경우, 본 사이트는 변경된 내용을 시행예정 30일전까지
            회원에게 통지함과 동시에 홈페이지 (www.kuhminsa.co.kr) 내의 공지 페이지에 공지하여야
            하며 회원이 적용 예정일까지 이의를 제기하지 않을 경우에는 변경된 약관을 승인한 것으로
            봅니다.
          </p>
          <p>회원이 이의를 제기한 때에는 본 사이트에 대하여 탈퇴의사를 밝힌 것으로 봅니다.</p>
          <h4>제4조 (본 약관에서 정하지 아니한 사항)</h4>
          <p>
            본 약관에서 정하지 아니한 사항과 본 약관의 해석에 관하여는 관계법령 또는 상관례에
            따릅니다.
          </p>
        </section>
        <section>
          <h3>제2장 회원의 가입 및 탈퇴</h3>
          <h4>제5조 (회원)</h4>
          <p>
            본 사이트 회원이란 구민사가 회원으로 적합하다고 인정하는 일반 개인으로서, 본 약관에
            동의하고 구민사가 인정하는 본 사이트의 회원가입양식을 작성한 뒤 고유의 ID와 PASSWORD를
            발급 받은 자를 말합니다.
          </p>
          <p>
            본 사이트에 기재하는 모든 정보는 이름을 포함하여 실제정보로 간주합니다. 그와 같이
            입력하지 않는 사용자는 법적인 보호를 받을 수 없으며 본 사이트의 서비스 제한 조치를 받을
            수 있습니다.
          </p>
          <h4>제6조 (가입과 탈퇴)</h4>
          <p>
            본 사이트에 가입을 희망하는 이용자는 본 사이트가 지정한 가입신청서를 작성하여야 하며, 본
            사이트는 이용자의 가입 신청 시 개인정보 수집과 관련하여 반드시 회원의 동의를 받아야
            합니다.
          </p>
          <p>
            제 1항의 경우, 가입을 희망하는 자가 본 사이트의 회원으로서 부적합 하다고 판단할 경우, 본
            사이트는 가입신청을 거절할 수 있으며, 이 경우 부적격사유를 통보하여야 합니다.
          </p>
          <p>회원은 언제든지 본 사이트의 회원에서 탈퇴할 수 있습니다.</p>
          <h4>제7조 (회원자격의 정지 및 박탈)</h4>
          <p>
            본 사이트는 회원이 다음 각 호에 해당되는 경우, 당해 회원에게 소명의 기회를 부여한 후
            회원의 자격을 일시 정지시킬 수 있습니다.
          </p>
          <ul>
            <li>① 가입신청서의 기재사항을 허위로 작성할 경우</li>
            <li>② 본 약관에서 정한 사항을 위반하는 경우</li>
          </ul>
          <p>
            본 사이트가 제1항에 의하여 회원의 자격을 일시 정지시킨 후, 동일한 행위가2회 이상
            반복되거나 또는 30일 이내에 그 사유가 시정되지 아니하는 경우, 본 사이트는 회원의 자격을
            박탈할 수 있습니다.
          </p>
        </section>
        <section>
          <h3>제3장 서비스의 이용</h3>
          <h4>제8조 (ID관리)</h4>
          <p>
            ID 및 비밀번호는 본 사이트와 협의 없이 타인에게 양도, 임대, 대여할 수 없으며, 회원ID와
            비밀번호에 관한 모든 관리 책임은 회원에게 있습니다.
          </p>
          <p>
            본 사이트는 회원ID에 의해 게시판 활동, 쇼핑 등 회원관리업무를 수행하며 본 사이트가
            인정하는 정당한 사유가 없는 한 회원은 ID를 공유, 양도 또는 변경할 수 없습니다.
          </p>
          <p>
            회원에게 부여된 ID 및 비밀번호의 관리소홀, 부정사용에 의하여 발생하는 모든 결과에 대한
            책임은 회원에게 있습니다.
          </p>
          <p>
            본 사이트는 회원과 관련된 개인 신상정보가 외부에 누출되지 않도록 보안에관련된 책임을 질
            의무가 있습니다.
          </p>
          <h4>제9조 (서비스 이용제한)</h4>
          <p>
            이용자는 서비스의 이용에 있어서 다음 각 호에 해당되지 않도록 하여야 하며, 이에 해당되는
            경우 서비스 이용을 제한할 수 있습니다.
          </p>
          <ul>
            <li>① 공공질서 및 미풍양속(욕설, 비난 포함)에 반하는 경우</li>
            <li>② 범죄적 행위에 관련되는 경우</li>
            <li>③ 타인의 명예를 손상시키거나 불이익을 주는 경우</li>
            <li>④ 서비스에 위해를 가하는 등 서비스의 건전한 이용을 저해하는 경우</li>
          </ul>
        </section>
        <section>
          <h3>제4장 계약사항</h3>
          <h4>제10조 (계약사항의 변경 및 해제)</h4>
          <p>
            이용자는 주소 등 이용계약 내용을 변경하거나, 서비스를 해지할 경우에는 본 사이트를 통해서
            이용계약을 변경 및 해지하여야 합니다.
          </p>
          <h4>제11조 (면책조항)</h4>
          <p>
            본 사이트는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지않습니다.
          </p>
          <p>
            본 사이트는 이용자가 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은자료로 인한
            손해에 관하여 책임을 지지 않습니다.
          </p>
          <h4>제12조 (저작권)</h4>
          <p>본 사이트에서 볼 수 있는 모든 자료는 구민사 에서 본 사이트로만 제공하는 정보입니다.</p>
          <h4>[부칙]</h4>
          <p>본 약관은 2013년 11월 05일부터 시행합니다.</p>
        </section>
      </div>
    </main>
  );
}
